import React, { Component } from "react";
import { connect } from "react-redux";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";

const SubMenu = Menu.SubMenu;

class HorizontalNav extends Component {
  getNavStyleSubMenuClass = navStyle => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve";
      default:
        return "gx-menu-horizontal";
    }
  };

  render() {
    const { pathname, navStyle } = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split("/")[1];
    const role = localStorage.getItem('role');
    return (
      <Menu
        defaultOpenKeys={[defaultOpenKeys]}
        selectedKeys={[selectedKeys]}
        mode="horizontal"
      >
        {role === 'admin' && <SubMenu
          className={this.getNavStyleSubMenuClass(navStyle)}
          key="data-define-update"
          title='Data management'
        >
          <Menu.Item key="data-define-price">
            <Link to="/data-define-price">
              <Icon type="edit" />
              People Rate Card
            </Link>
          </Menu.Item>
          <Menu.Item key="data-define-price-by-data-level">
            <Link to="/data-define-price-by-data-level">
              <Icon type="edit" />
              Data level
            </Link>
          </Menu.Item>
          <Menu.Item key="data-define-price-by-report-level">
            <Link to="/data-define-price-by-report-level">
              <Icon type="edit" />
              Working hour by report level
            </Link>
          </Menu.Item>
          <Menu.Item key="data-define-category">
            <Link to="/data-define-category">
              <Icon type="edit" />
              Standard data by category
            </Link>
          </Menu.Item>
        </SubMenu>
        }
        {['line-manager', 'admin'].includes(role) &&<SubMenu
          className={this.getNavStyleSubMenuClass(navStyle)}
          key="data-import"
          title='Data import'
        >
          <SubMenu
            className={this.getNavStyleSubMenuClass(navStyle)}
            key="data-buzz"
            title='Brand Data'
          >
            <Menu.Item key="list-buzz">
              <Link to="/list-buzz">
                <Icon type="file-search" />
                Search
              </Link>
            </Menu.Item>
            <Menu.Item key="insert-buzz">
              <Link to="/insert-buzz">
                <Icon type="folder-add" />
                Create
              </Link>
            </Menu.Item>
            <Menu.Item key="migrate-data-buzz">
              <Link to="/migrate-data-buzz">
                <Icon type="file-excel" />
                Import
              </Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu
            className={this.getNavStyleSubMenuClass(navStyle)}
            key="data-campaign"
            title='Campaign Data'
          >
            <Menu.Item key="list-campaign">
              <Link to="/list-campaign">
                <Icon type="file-search" />
                Search
              </Link>
            </Menu.Item>
            <Menu.Item key="insert-campaign">
              <Link to="/insert-campaign">
                <Icon type="folder-add" />
                Create
              </Link>
            </Menu.Item>
            <Menu.Item key="migrate-data-campaign">
              <Link to="/migrate-data-campaign">
                <Icon type="file-excel" />
                Import
              </Link>
            </Menu.Item>
          </SubMenu>
        </SubMenu>}
        <Menu.Item key="analysis-level-guide">
          <Link to="/analysis-level-guide">
            Analysis Level Guide
          </Link>
        </Menu.Item>
        {role === 'admin' && <SubMenu
          className={this.getNavStyleSubMenuClass(navStyle)}
          key="data-user"
          title='User management'
        >
          <Menu.Item key="list-user">
            <Link to="/list-user">
              <Icon type="team" />
              Role permission
            </Link>
          </Menu.Item>
          <Menu.Item key="insert-user">
            <Link to="/insert-user">
              <Icon type="user-add" />
              Add user
            </Link>
          </Menu.Item>
        </SubMenu>}
      </Menu>
    );
  }
}

HorizontalNav.propTypes = {};
const mapStateToProps = ({ settings }) => {
  const { themeType, navStyle, pathname, locale } = settings;
  return { themeType, navStyle, pathname, locale };
};
export default connect(mapStateToProps)(HorizontalNav);
